/**
 * String constants for EDMS Repositories page.
 */

export const PAGE = {
  title: 'Repositories',
  description:
    'Manage Repositories used in the document management system. Use the filters below to refine the list.',
};

export const ACTIONS = {
  create: 'Create Repository',
  edit: 'Update Repository',
  delete: 'Delete Repository',
  cancel: 'Cancel',
};

export const SEARCH = {
  placeholder: 'Search repositories…',
  inputId: 'repository-search',
};

export const ACTIVE_FILTER = {
  selectId: 'repository-active',
};

export const MESSAGES = {
  createSuccess: 'Repository created successfully.',
  createError: 'Unable to create Repository. Please try again.',
  updateSuccess: 'Repository updated successfully.',
  updateError: 'Unable to update Repository. Please try again.',
  updateMissingId: 'Unable to update Repository: missing Repository identifier.',
  deleteSuccess: 'Repository deleted successfully.',
  deleteError: 'Unable to delete Repository. Please try again.',
};

export const CONFIRM = {
  updateTitle: 'Update Repository?',
  updateMessage: 'Apply the pending changes?',
  deleteTitle: 'Delete Repository?',
  deleteMessage: (name) =>
    `This will remove "${name || 'this Repository'}" and any linked records. This action cannot be undone.`,
};

export const SUCCESS_DIALOG = {
  successTitle: 'Success',
  errorTitle: 'Action required',
};
